/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DesignSurfaceInfiltration } from "./DesignSurfaceInfiltration";
import {
  DesignSurfaceInfiltrationFromJSON,
  DesignSurfaceInfiltrationFromJSONTyped,
  DesignSurfaceInfiltrationToJSON,
  DesignSurfaceInfiltrationToJSONTyped,
} from "./DesignSurfaceInfiltration";

/**
 *
 * @export
 * @interface ApiGufSurfaceinfiltrationsList200Response
 */
export interface ApiGufSurfaceinfiltrationsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGufSurfaceinfiltrationsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGufSurfaceinfiltrationsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGufSurfaceinfiltrationsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<DesignSurfaceInfiltration>}
   * @memberof ApiGufSurfaceinfiltrationsList200Response
   */
  results: Array<DesignSurfaceInfiltration>;
}

/**
 * Check if a given object implements the ApiGufSurfaceinfiltrationsList200Response interface.
 */
export function instanceOfApiGufSurfaceinfiltrationsList200Response(
  value: object
): value is ApiGufSurfaceinfiltrationsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGufSurfaceinfiltrationsList200ResponseFromJSON(
  json: any
): ApiGufSurfaceinfiltrationsList200Response {
  return ApiGufSurfaceinfiltrationsList200ResponseFromJSONTyped(json, false);
}

export function ApiGufSurfaceinfiltrationsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGufSurfaceinfiltrationsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(DesignSurfaceInfiltrationFromJSON),
  };
}

export function ApiGufSurfaceinfiltrationsList200ResponseToJSON(
  json: any
): ApiGufSurfaceinfiltrationsList200Response {
  return ApiGufSurfaceinfiltrationsList200ResponseToJSONTyped(json, false);
}

export function ApiGufSurfaceinfiltrationsList200ResponseToJSONTyped(
  value?: ApiGufSurfaceinfiltrationsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(DesignSurfaceInfiltrationToJSON),
  };
}
